module.exports = {"legal-notice":"Aviso legal y cookies"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/mx/public/footer-opensalud.json
// module id = 612
// module chunks = 120